export default "__VITE_ASSET__DDI1qMI0__"